import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { AnalysisData } from '@sleipai/sleip-models';
import * as fromReview from './review.reducer';

export function selectReviewId(review: AnalysisData) {
  return review.id ?? '';
}

export function sortReviewByDate(a: any, b: any) {
  const dateA = new Date(a.date.seconds).toString();
  const dateB = new Date(b.date.seconds).toString();
  return dateA.localeCompare(dateB);
}

export const reviewAdapter: EntityAdapter<AnalysisData> = createEntityAdapter<AnalysisData>({
  selectId: selectReviewId,
  sortComparer: sortReviewByDate,
});

export const selectReviewState = (state: fromReview.State) => state.reviews;
export const { selectAll: selectAllReviews } = reviewAdapter.getSelectors();

export interface ReviewsState extends EntityState<AnalysisData> {}
